<template>
  <BgImageLayout title="Subject Categories" :page="__guide.subjectCategories" icon-color="white">
    <CreateSubjectCategoryModal v-model="createModal" @save="create" />

    <AgGridWrapper
      ref="agGrid"
      :options="gridOptions"
      :actions="actions"
      class="full-height"
      include-search-box
      handle-update-on-parent
      @open-create-modal="createModal = true"
      @cell-updated="update"
    />
  </BgImageLayout>
</template>

<script>
import { dateRenderer, dateSorter } from '@/lib/generic.utils'
import * as apiTo from './api'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'
import CreateSubjectCategoryModal from '@/reusable/CreateSubjectCategoryModal'
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import ConfirmationDialog from '@/reusable/ConfirmationDialog/ConfirmationDialog'

export default {
  components: {
    AgGridWrapper,
    CreateSubjectCategoryModal
  },

  data: () => ({
    rows: null,
    createModal: false
  }),

  computed: {
    gridOptions() {
      return {
        rowData: this.rows,
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            editable: true,
            cellRenderer: params => params.value || 'N/A'
          },
          {
            headerName: 'Created',
            field: 'created_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Updated',
            field: 'updated_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Actions',
            cellRendererFramework: LmEntityActions
          }
        ],
        context: {
          actions: [
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.delete,
              color: 'faded'
            }
          ]
        },
        domLayout: 'normal'
      }
    },

    actions() {
      return [
        {
          label: 'Create new subject category',
          event: 'open-create-modal',
          type: 'button',
          color: 'tertiary',
          size: 'md'
        }
      ]
    }
  },

  created() {
    apiTo.getSubjectCategories().then(({ data }) => (this.rows = data.result))
  },

  methods: {
    create(name) {
      apiTo.createSubjectCategory({ name }).then(({ data }) => this.rows.push(data.result))
    },

    update({ data }) {
      apiTo.updateSubjectCategory(data.id, { name: data.name }).then(({ data }) => {
        const index = this.rows.findIndex(r => r.id === data.result.id)
        if (~index) this.rows.splice(index, 1, data.result)
      })
    },

    async delete({ data: { id } }) {
      const { data } = await apiTo.getDeleteConfirmation(id)
      this.$q
        .dialog({
          component: ConfirmationDialog,
          title: 'Confirm',
          messages: data.messages.default
        })
        .onOk(() => {
          apiTo.deleteSubjectCategory(id).then(() => {
            const index = this.rows.findIndex(r => r.id === id)
            if (~index) this.rows.splice(index, 1)
          })
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

styledScrollFor('>>> .ag-body-viewport.ag-layout-normal');

>>> .ag-theme-material {
  height 100%
}

>>> .table-content {
  padding 0 40px
  height 100%
}

.ag-grid-wrapper-card {
  display grid
  grid-template-rows 50px 2px 1fr 35px
}
</style>
